export default __webpack_public_path__ + "static/media/Ascher.59ab0b20.png";